import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// During react-snap prerender the origin is localhost (cross-origin to the API),
// so credentialed requests are blocked by the wildcard CORS policy. Drop credentials
// only in that build-time crawl so per-page SEO data can be fetched and baked in.
const isPrerender = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const api = axios.create({ baseURL: API, withCredentials: !isPrerender });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
